import { render } from "./index.vue?vue&type=template&id=c5f5673c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c5f5673c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f5673c"],['__file',"vendor/vvg/forum/resources/vue/forum/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5f5673c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5f5673c', __exports__)) {
    console.log('reload')
    api.reload('c5f5673c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c5f5673c&scoped=true", () => {
    console.log('re-render')
    api.rerender('c5f5673c', render)
  })

}


export default __exports__